import { render } from "./LoadingPanel.vue?vue&type=template&id=407c39b6"
import script from "./LoadingPanel.vue?vue&type=script&lang=js"
export * from "./LoadingPanel.vue?vue&type=script&lang=js"

import "./LoadingPanel.vue?vue&type=style&index=0&id=407c39b6&lang=css"
script.render = render

export default script